var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-pane" },
    [
      _c("div", { staticClass: "pane-head" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "ph-actions" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary", icon: "el-icon-plus" },
                on: { click: _vm.handleAdd },
              },
              [
                _c("bi-label", {
                  attrs: { zh: "新增文案", pt: "Novo Texto", inline: "" },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "template-list" },
        [
          _vm._l(_vm.rows, function (t, i) {
            return _c(
              "div",
              { key: t.alertType, staticClass: "template-item" },
              [
                _c("div", { staticClass: "t-num" }, [
                  _vm._v(_vm._s(_vm.pad2(i + 1))),
                ]),
                _c("div", { staticClass: "t-body" }, [
                  _c("div", { staticClass: "t-label" }, [
                    _c(
                      "span",
                      {
                        staticClass: "t-type",
                        class: _vm.typeCls(t.alertType),
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.typeZh(t.alertType)) + " "),
                        _c("span", { staticClass: "t-type-pt" }, [
                          _vm._v("/ " + _vm._s(_vm.typePt(t.alertType))),
                        ]),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "t-line" }, [
                    _vm._m(1, true),
                    _c("div", { staticClass: "t-v" }, [
                      _vm._v(_vm._s(t.title || "—")),
                    ]),
                  ]),
                  _c("div", { staticClass: "t-line" }, [
                    _vm._m(2, true),
                    _c("div", { staticClass: "t-v t-v-pre" }, [
                      _vm._v(_vm._s(t.content || "—")),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "t-vars" },
                    [
                      _vm._m(3, true),
                      _vm._l(_vm.varsOf(t.alertType), function (v) {
                        return _c("div", { key: v, staticClass: "var" }, [
                          _c("span", [_vm._v("{")]),
                          _vm._v(_vm._s(v)),
                          _c("span", [_vm._v("}")]),
                        ])
                      }),
                    ],
                    2
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "t-actions" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(t)
                          },
                        },
                      },
                      [
                        _c("bi-label", {
                          attrs: {
                            zh: "编辑文案",
                            pt: "Editar Texto",
                            inline: "",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.openTestPush(t)
                          },
                        },
                      },
                      [
                        _c("bi-label", {
                          attrs: {
                            zh: "测试推送",
                            pt: "Testar Envio",
                            inline: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            )
          }),
          !_vm.rows.length && !_vm.loading
            ? _c("div", { staticClass: "list-empty" }, [
                _vm._v(" 接口暂无告警文案数据 "),
                _c("span", { staticClass: "empty-pt" }, [
                  _vm._v("/ Nenhum texto de alerta retornado pela API"),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "640px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "td-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.isAdd
                      ? "新增文案"
                      : "编辑文案 · " + _vm.typeZh(_vm.current.alertType)
                  )
                ),
              ]),
              _c("span", { staticClass: "td-pt" }, [
                _vm._v(
                  "/ " +
                    _vm._s(
                      _vm.isAdd
                        ? "Novo Texto"
                        : "Editar Texto · " + _vm.typePt(_vm.current.alertType)
                    )
                ),
              ]),
            ]
          ),
          _vm.dialogVisible
            ? _c(
                "el-form",
                {
                  ref: "formRef",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-position": "top",
                    size: "small",
                  },
                },
                [
                  _vm.isAdd
                    ? _c(
                        "el-form-item",
                        { attrs: { prop: "alertType" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "告警类型",
                                  pt: "Tipo de Alerta",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder:
                                  "请选择告警类型 / Selecione o tipo de alerta",
                              },
                              model: {
                                value: _vm.form.alertType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "alertType", $$v)
                                },
                                expression: "form.alertType",
                              },
                            },
                            _vm._l(_vm.typeOptions, function (t) {
                              return _c("el-option", {
                                key: t.value,
                                attrs: { label: t.label, value: t.value },
                              })
                            }),
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "title" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("bi-label", {
                            attrs: { zh: "标题", pt: "Título", inline: "" },
                          }),
                        ],
                        1
                      ),
                      _c("el-input", {
                        attrs: { maxlength: "60", "show-word-limit": "" },
                        model: {
                          value: _vm.form.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "title", $$v)
                          },
                          expression: "form.title",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "content" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("bi-label", {
                            attrs: { zh: "内容", pt: "Conteúdo", inline: "" },
                          }),
                        ],
                        1
                      ),
                      _c("el-input", {
                        attrs: { type: "textarea", rows: 4 },
                        model: {
                          value: _vm.form.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "content", $$v)
                          },
                          expression: "form.content",
                        },
                      }),
                    ],
                    2
                  ),
                  _c("div", { staticClass: "td-hint" }, [
                    _vm._v(" 变量以 {名称} 形式插入，推送时自动替换： "),
                    _c(
                      "span",
                      { staticClass: "td-vars" },
                      _vm._l(
                        _vm.varsOf(
                          _vm.isAdd ? _vm.form.alertType : _vm.current.alertType
                        ),
                        function (v) {
                          return _c("span", { key: v, staticClass: "var" }, [
                            _c("span", [_vm._v("{")]),
                            _vm._v(_vm._s(v)),
                            _c("span", [_vm._v("}")]),
                          ])
                        }
                      ),
                      0
                    ),
                    _c("span", { staticClass: "td-hint-pt" }, [
                      _vm._v(
                        "/ Variáveis no formato {nome}, substituídas automaticamente no envio"
                      ),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "td-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [
                  _c("bi-label", {
                    attrs: { zh: "取消", pt: "Cancelar", inline: "" },
                  }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.saving,
                  },
                  on: { click: _vm.handleSave },
                },
                [
                  _c("bi-label", {
                    attrs: { zh: "保存", pt: "Salvar", inline: "" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.testVisible,
            width: "520px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.testVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "td-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("span", [
                _vm._v(
                  "测试推送 · " + _vm._s(_vm.typeZh(_vm.testTarget.alertType))
                ),
              ]),
              _c("span", { staticClass: "td-pt" }, [
                _vm._v(
                  "/ Testar Envio · " +
                    _vm._s(_vm.typePt(_vm.testTarget.alertType))
                ),
              ]),
            ]
          ),
          _c(
            "el-form",
            { attrs: { "label-position": "top", size: "small" } },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "template",
                    { slot: "label" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "接收人", pt: "Destinatário", inline: "" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请选择接收人 / Selecione o destinatário",
                      },
                      model: {
                        value: _vm.testRecipientId,
                        callback: function ($$v) {
                          _vm.testRecipientId = $$v
                        },
                        expression: "testRecipientId",
                      },
                    },
                    _vm._l(_vm.recipients, function (r) {
                      return _c("el-option", {
                        key: r.id,
                        attrs: { label: r.name, value: r.id },
                      })
                    }),
                    1
                  ),
                  _c("div", { staticClass: "td-hint" }, [
                    _vm._v(
                      " 将向所选飞书群发送一条示例告警，发送成功后该接收人连通性恢复为「正常」 "
                    ),
                    _c("span", { staticClass: "td-hint-pt" }, [
                      _vm._v(
                        'Enviará um alerta de exemplo ao grupo selecionado; após o envio a saúde volta a "Normal"'
                      ),
                    ]),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "td-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.testVisible = false
                    },
                  },
                },
                [
                  _c("bi-label", {
                    attrs: { zh: "取消", pt: "Cancelar", inline: "" },
                  }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.pushing,
                    disabled: !_vm.testRecipientId,
                  },
                  on: { click: _vm.handleTestPush },
                },
                [
                  _c("bi-label", {
                    attrs: { zh: "发送测试", pt: "Enviar Teste", inline: "" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ph-tip" }, [
      _vm._v(" 变量以 {名称} 形式插入，推送时自动替换 "),
      _c("span", { staticClass: "tip-pt" }, [
        _vm._v(
          "Variáveis no formato {nome}, substituídas automaticamente no envio"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "t-k" }, [
      _vm._v("标题"),
      _c("span", { staticClass: "t-k-pt" }, [_vm._v(" / Título")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "t-k" }, [
      _vm._v("内容"),
      _c("span", { staticClass: "t-k-pt" }, [_vm._v(" / Conteúdo")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vars-title" }, [
      _vm._v("可用变量"),
      _c("span", { staticClass: "vars-title-pt" }, [_vm._v(" / Variáveis")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }